<script setup lang="ts">
import { Divider } from "~/components/clarity-ui/Divider";
import { Heading } from "~/components/clarity-ui/Heading";
import useMarketSetup from "~/composables/useMarketSetup";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import ShopBenefits from "~/templates/components/shop/product/ShopBenefits.vue";

const { $msal } = useNuxtApp();
const { marketSetup } = useMarketSetup();

const loginMsal = () => $msal.signIn();
const signUpMsal = () => $msal.signUp();
</script>

<template>
  <div class="grid gap-6 xl:gap-7">
    <Heading size="medium" tag="h2">
      <CommonLabel path="BWF/shop/shared/alreadyRegistered" />
    </Heading>
    <button class="btn btn-blue md:btn-size-normal w-full" @click="loginMsal">
      <CommonLabel path="BWF/shop/checkout/mybrita/loginToMybrita" />
    </button>

    <Divider class="md:my-2 xl:my-5" />

    <Heading size="medium" tag="h2">
      <CommonLabel path="BWF/shop/checkout/mybrita/registerNow" />
    </Heading>
    <ShopBenefits :benefits="marketSetup?.myBritaBenefits" />
    <button class="btn btn-blue md:btn-size-normal w-full" @click="signUpMsal">
      <CommonLabel path="BWF/shop/checkout/mybrita/createAccount" />
    </button>
  </div>
</template>
